import 'url-polyfill';
var Promise = require('es6-promise').Promise;
import "@babel/polyfill";
import Vue from 'vue';
import _ from 'lodash';
import axios from 'axios';

var listWrapper = document.querySelector('main .wrapper');
var scrollPoint = listWrapper.offsetTop - 100;

const app = new Vue({
    delimiters: ['${', '}'],

    el: '.js-app',

    data: {

        // Initial Resources
        topData: [],
        firstLoad: false,

        // Tied to parameters sent to the element-api
        filters: {
            time: '',
            page: 1
        },

        // Tracks page count for rendering pagination nav.
        // This is directly wired to what the element api indicates.
        pageCount: null,
        loading: false,

        currentUrl: ''

    },
    computed: {

        // Ties Params and Filters together
        currentFilters() {
            let endFilters = {}

            for (let param in this.filters) {
                if(this.filters[param]) {
                    endFilters[param] = this.filters[param];
                }
            }

            return endFilters;
        },

        // Sends data to DOM for rendering
        finalData() {
            return this.topData
        },

        paginationLinks() {
            let radius = 2;
            let links = [];
            let current = this.filters.page;
            let max = this.pageCount;
            let low = Math.max(current - radius, 1);
            let high = Math.min(current + radius, max);

            if (current > 1) {
                links.push({page: current - 1, label: 'Previous', active: false});
            }

            if (low > 1) {
                links.push({page: 1, label: 1, active: false});
            }

            if (low > 3) {
                links.push({label: '…'});
            } else if (low == 3) {
                links.push({page: 2, label: 2, active: false});
            }


            for (let i = low; i <= high; i++) {
                links.push({page: i, label: i, active: i == current});
            }


            if (high < (max - 2)) {
                links.push({label: '…'});
            } else if (high == max - 2) {
                links.push({page: high + 1, label: high + 1, active: false});
            }

            if (high < max) {
                links.push({page: max, label: max, active: false});
            }

            if (current < max) {
                links.push({page: current + 1, label: 'Next', active: false});
            }

            return links;
        },
    },
    methods: {
        search(pageNumber) {
            if (parseInt(pageNumber)) {
                this.filters.page = pageNumber;
            } else {
                this.filters.page = 1;
            }
            this.navigated = false;
            this.updateUrl();
            this.getData();
        },

        // Requests data and delegates crucial parts of the response
        getData() {            

            if(this.firstLoad) {
                window.scrollTo(0, scrollPoint);
            }

            // Hook for loading view
            this.loading = true;

            setTimeout(()=>{ 
                axios
                    .request('/press.json', {
                        method: 'get',
                        params: this.currentFilters
                    })
                    .then(({data, status}) => {
                        this.topData = data.data;
                        this.filters.page = data.meta.pagination.current_page;
                        this.pageCount = data.meta.pagination.total_pages;

                        // Removes loading view
                        this.loading = false;
                    });
            },500);

            if(this.firstLoad) {
                this.updateUrl();
            }

            this.firstLoad = true;
        },

        dateFormat(dateObj) {
            return moment(dateObj);
        },

        // Method for navigating using pagination
        updateCurrentPage(event) {
            this.filters.page = event.currentTarget.getAttribute('data-page');
            window.scrollTo(0, 50);
            this.navigated = true;
            this.getData();
        },

        // Previous Page
        previous() {
            this.filters.page--;
            this.navigated = true;
            this.getData();
        },

        //Next Page
        next() {
            this.filters.page++;
            this.navigated = true;
            this.getData();
        },

        // Updates Vue state if params are passed
        getParams() {
            var url_string = window.location.href;
            var url = new URL(url_string);
            
            this.filters.time = url.searchParams.get("time");
            this.filters.page = url.searchParams.get("page");
        },

        // Creates parameters for use in generating current URL
        createParams(obj) {
            let str = '';
            for (var key in obj) {
                if (encodeURIComponent(obj[key]) != 'null') {
                    if (str != '') {
                        str += '&';
                    }  else {
                        str += '?';
                    }
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            return str;
        },

        //Updates URL for shareability
        updateUrl() {

            if (window.history.replaceState) {
                window.history.replaceState(
                    {}, document.title, (this.currentUrl + this.createParams(this.filters))
                );
            }

        }
    },
    mounted() {
        this.getParams();
        this.getData();
    }

});